import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Region } from "../constants/CommonConst";

export const useContactUsHelper = (masterLayoutState) => {
  const location = useLocation();
  useEffect(() => {
    if (
      masterLayoutState.contactList &&
      masterLayoutState.contactList.countrycode !== Region.MALAYSIA
    ) {
      const scriptUrl =
        "https://plugin-code.salesmartly.com/js/project_308335_316752_1744960222.js";

      const isScriptExist = document.querySelector(
        `script[src="${scriptUrl}"]`
      );

      if (!isScriptExist && !location.pathname.includes("/gamePlay")) {
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        document.head.appendChild(script);
        const timeout = setTimeout(() => {
          document.getElementById("ss-chat-custom-css")?.remove();
        }, 500);

        return () => clearTimeout(timeout);
      } else {
        const isChatElementExist = document.getElementById("ss-chat-p");
        if (location.pathname.includes("/gamePlay") && isChatElementExist) {
          isChatElementExist.classList.add("d-none");
        } else if (isChatElementExist) {
          isChatElementExist.classList.remove("d-none");
        }
      }
    }
  }, [masterLayoutState.contactList, location.pathname]);
};
